import React, { useContext } from "react";
import { observer } from "mobx-react";
import { Popover } from "antd";

import "./filter-list.scss";
import Icon from "../../components/icon/Icon";
import articleStore from "../../stores/articleStore";
import { isMobile } from "../../utils/tools";

interface Props {
  onFilterChange: () => void;
}

const FilterList: React.FC<Props> = (props: Props) => {
  const { onFilterChange = () => {} } = props;
  const {
    publishOption,
    sortOption,
    tags,
    choosePublish,
    chooseSort,
    chooseTags,
    clearChoose,
    revert,
    chooseOption,
    chooseTag,
    openName,
    setOpenName,
    showClear,
  } = useContext(articleStore);

  return (
    <div className="filter-list">
      {!isMobile() && showClear && (
        <div
          className="filter-list__clear"
          onClick={() => {
            clearChoose();
            onFilterChange();
          }}
        >
          <Icon name="clear-close" size={12} />
          清除全部
        </div>
      )}
      {/* 发布时间选项 */}
      {publishOption && publishOption.length > 0 && (
        <Popover
          content={
            <div className="filter-list__pannel">
              {publishOption.map(item => (
                <div
                  key={item.label}
                  className={`filter-list__inline ${item.label ===
                    choosePublish && "is-active"}`}
                  onClick={() => {
                    chooseOption("publishOption", item.label);
                    revert();
                    onFilterChange();
                  }}
                >
                  {item.value}
                  <i className="iconfont icon-true filter-list__checked" />
                </div>
              ))}
            </div>
          }
          visible={openName === "time"}
          trigger="click"
          getPopupContainer={() =>
            document.querySelector(".filter-list__item-time") || document.body
          }
        >
          <div
            className="filter-list__item filter-list__item-time"
            onClick={e => {
              e.stopPropagation();
              setOpenName("time");
            }}
          >
            <span className="filter-list__top">
              发布时间
              <Icon name="triangle-down" size={6} color="#8F8E9F" />
            </span>
          </div>
        </Popover>
      )}
      {/* 排序选项 */}
      {sortOption && sortOption.length > 0 && (
        <Popover
          content={
            <div className="filter-list__pannel">
              {sortOption.map(item => (
                <div
                  key={item.label}
                  className={`filter-list__inline ${item.label === chooseSort &&
                    "is-active"}`}
                  onClick={() => {
                    chooseOption("sortOption", item.label);
                    revert();
                    onFilterChange();
                  }}
                >
                  {item.value}
                  <i className="iconfont icon-true filter-list__checked" />
                </div>
              ))}
            </div>
          }
          visible={openName === "sort"}
          trigger="click"
          getPopupContainer={() =>
            document.querySelector(".filter-list__item-sort") || document.body
          }
        >
          <div
            className="filter-list__item filter-list__item-sort"
            onClick={e => {
              e.stopPropagation();
              setOpenName("sort");
            }}
          >
            <span className="filter-list__top">
              排 序<Icon name="triangle-down" size={6} color="#8F8E9F" />
            </span>
          </div>
        </Popover>
      )}
      {/* 根据标签 */}
      {tags && tags.length > 0 && (
        <Popover
          content={
            <div className="filter-list__tags-wrapper">
              <div className="filter-list__tags">
                {tags.map((item, index) => (
                  <div
                    key={index}
                    className={`filter-list__link ${chooseTags.includes(item) &&
                      "is-active"}`}
                    onClick={() => {
                      chooseTag(item);
                      revert();
                      onFilterChange();
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          }
          visible={openName === "tags"}
          trigger="click"
          placement="bottomRight"
          getPopupContainer={() =>
            document.querySelector(".filter-list__item-tags") || document.body
          }
        >
          <div
            className="filter-list__item filter-list__item-tags"
            onClick={e => {
              e.stopPropagation();
              setOpenName("tags");
            }}
          >
            <span className="filter-list__top">
              根据标签
              <Icon name="triangle-down" size={6} color="#8F8E9F" />
            </span>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default observer(FilterList);
